import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { SetAlertBasic } from "../../../general/components/Alert/modul/alertBasicAction";

export default function useInfoAssessorLeave(props) {
  const { listUserData } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    if (listUserData?.length > 0) {
      let l = listUserData.filter(
        (x) => x.type == "ASSESSOR" && x?.agora != null
      ).length;
      console.log("TESTING 004 USEFFECT", l, listUserData);
      sendAlert(l > 0);
    }
  }, [listUserData]);

  const sendAlert = (b) => {
    let objA;
    if (b) {
      objA = {
        code: "ASSESSOR_LEAVE",
        type: null,
        mess: null,
        manualClose: false,
      };
    } else {
      objA = {
        code: "ASSESSOR_LEAVE",
        type: "INFO",
        mess: "Please wait for the Assessor",
        manualClose: false,
      };
    }
    console.log("TESTING 004 sendAlert", objA);

    dispatch(SetAlertBasic(objA));
  };
}
